import type { SVGProps } from "react";

export function AnthropicLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      {/* 8-branch asterisk */}
      <g>
        <rect x="11" y="2" width="2" height="20" />
        <rect x="2" y="11" width="20" height="2" />
        <rect
          x="11"
          y="2"
          width="2"
          height="20"
          transform="rotate(45 12 12)"
        />
        <rect
          x="11"
          y="2"
          width="2"
          height="20"
          transform="rotate(-45 12 12)"
        />
      </g>
    </svg>
  );
}
